export const AboutUsData = [
  { number: "12+", label: "Years Helping Business" },
  { number: "10+", label: "Technologies" },
  { number: "5+", label: "Domains" },
  { number: "50+", label: "Complete Projects" },
];
